import { cn } from "@/lib/utils";

type Severity = "CRITICAL" | "ATTENTION" | "OBSERVATION" | "OPPORTUNITY";

const STYLES: Record<Severity, string> = {
	CRITICAL: "bg-rose-100 text-rose-900 border-rose-200",
	ATTENTION: "bg-amber-100 text-amber-900 border-amber-200",
	OBSERVATION: "bg-slate-100 text-slate-800 border-slate-200",
	OPPORTUNITY: "bg-emerald-100 text-emerald-900 border-emerald-200",
};

const LABELS: Record<Severity, string> = {
	CRITICAL: "High",
	ATTENTION: "Medium",
	OBSERVATION: "Info",
	OPPORTUNITY: "Positive",
};

type Props = {
	severity: Severity;
	className?: string;
};

export function IntelligenceSeverityBadge({ severity, className }: Props) {
	return (
		<span
			className={cn(
				"inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
				STYLES[severity],
				className
			)}
		>
			{LABELS[severity]}
		</span>
	);
}
